import img from "../../../img/person.svg";
import img2 from "../../../img/corporate.svg";
import img3 from "../../../img/business.svg";
import img4 from "../../../img/custom.svg";

export const loans = [
  {
    img: img,
    title: "Personal Loans",
    price: "$50,000",
    bg: "rgb(231, 237, 255)",
  },
  {
    img: img2,
    title: "Corporate Loans",
    price: "$100,000",
    bg: "rgb(255, 245, 217)",
  },
  {
    img: img3,
    title: "Business Loans",
    price: "$500,000",
    bg: "rgb(255, 224, 235)",
  },
  {
    img: img4,
    title: "Custom Loans",
    price: "Choose Money",
    bg: "rgb(220, 250, 248)",
  },
];

export const loansTableData = [
  {
    id: "01",
    loan: 100000,
    left_repay: 40500,
    month: "8",
    percent: 12,
    installment: 2000,
  },
  {
    id: "02",
    loan: 500000,
    left_repay: 250000,
    month: "36",
    percent: 10,
    installment: 8000,
  },
  {
    id: "03",
    loan: 900000,
    left_repay: 40500,
    month: "12",
    percent: 12,
    installment: 5000,
  },
  {
    id: "04",
    loan: 50000,
    left_repay: 40500,
    month: "25",
    percent: 5,
    installment: 2000,
  },
  {
    id: "05",
    loan: 50000,
    left_repay: 40500,
    month: "5",
    percent: 16,
    installment: 10000,
  },
  {
    id: "06",
    loan: 80000,
    left_repay: 25500,
    month: "14",
    percent: 8,
    installment: 2000,
  },
  {
    id: "07",
    loan: 12000,
    left_repay: 5500,
    month: "9",
    percent: 13,
    installment: 500,
  },
  {
    id: "08",
    loan: 160000,
    left_repay: 100800,
    month: "3",
    percent: 12,
    installment: 900,
  },
];
